export const InsightsOperation = {
  Information: 'traceInformation',
  Warning: 'traceWarning',
  Error: 'traceError',
  Tag: 'tag',
};

export const PermissionStatus = {
  Approved: 'approved',
  Rejected: 'rejected',
  Uninitialized: 'uninitialized',
};

export const InsightsRestrictions = {
  Environments: 'environments',
};
